import intro from '../pages/intro/page.js';
import outro from '../pages/outro_billboard/page.js';
import game from '../pages/billboard/page.js';

let parent;
let _clb;

const intro_page=()=>intro.show({
	cls:'',
	header:'Design a billboard',
	desc:[
		'There is construction on the road to Cumberland Island. Many drivers are not paying attention and slowing down.',
		'Design a billboard that tells drivers to be extra careful in areas where people are working on the road.'
	],
	clb:game_page,
	parent
});

const game_page=()=>game.show({
	parent,
	clb:outro_page
});

const outro_page=(choices)=>outro.show({
	cls:'billboard',
	header:'Great job!',
	desc:[
		'You\'ve arrived at Cumberland Island and created a beautiful billboard!'
	],
	parent,
	choices,
	clb:()=>{
		if(_clb) _clb();
		_clb = undefined;
	}
});

const _ext={
	start:({container,clb})=>{
		parent = container;
		_clb=clb;
		intro_page();
	},
	stop:()=>{
		game.hide();
	}
}

export default _ext;
